import React from 'react';
import Typewriter from 'typewriter-effect';

function Type() {
    return (
        <Typewriter
            options={{
                strings: [
                    'Researcher',
                    'Computational Biology Enthusiast',
                    'Teacher',
                    'Competitive Programmer',
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 50,
            }}
        />
    );
}

export default Type;
